import type { SectionSlotView, SectionView } from '@nopain-newsletter/core/sections';

function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

/** "5 texts, 1 image, 1 link": what can be changed in a section. */
export function slotSummary(slots: readonly SectionSlotView[]): string {
  const texts = slots.filter((s) => s.kind === 'text').length;
  const images = slots.filter((s) => s.kind === 'image').length;
  const links = slots.filter((s) => s.kind === 'link' || s.kind === 'button').length;
  const parts = [
    texts > 0 ? plural(texts, 'text', 'texts') : null,
    images > 0 ? plural(images, 'image', 'images') : null,
    links > 0 ? plural(links, 'link', 'links') : null,
  ].filter((p): p is string => p !== null);
  return parts.length > 0 ? parts.join(', ') : 'Nothing to change';
}

export function problemCount(section: SectionView): number {
  return section.hidden ? 0 : section.slots.reduce((n, slot) => n + slot.problems.length, 0);
}

/** The sections that take part in the order (the frame around the rows does not). */
export function rowSections(sections: readonly SectionView[]): SectionView[] {
  return sections.filter((s) => s.rows !== null);
}

const KIND_LABEL: Record<SectionSlotView['kind'], string> = {
  text: 'Text',
  image: 'Image',
  link: 'Link',
  button: 'Button',
};

/** A short name for a slot in lists: its kind and the start of what it holds. */
export function slotLabel(slot: SectionSlotView): { kind: string; value: string } {
  const value =
    slot.kind === 'text'
      ? (slot.values.text ?? '')
      : slot.kind === 'image'
        ? slot.values.alt || 'No description'
        : (slot.values.href ?? '');
  return { kind: KIND_LABEL[slot.kind], value: value.replace(/\s+/g, ' ').trim() || '(empty)' };
}
